import { SR_API_ACTION_ONSWITCH_GET_ORDER_WORKFLOW_CONTEXT } from 'api/utilityActionTypes';

export default async function getOrderWorkflowContext(
  { state, utilityApiClient },
  { onSwitchOrderId, forceRefresh = false },
) {
  if (!onSwitchOrderId) {
    return null;
  }

  const statePath = ['onSwitch', 'workflowContextByOrderId', onSwitchOrderId];
  if (state.get(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_ONSWITCH_GET_ORDER_WORKFLOW_CONTEXT,
    state: state,
    queryId: onSwitchOrderId,
    payload: {
      onSwitchOrderId,
    },
    onSuccess(workflowContext) {
      state.set(statePath, workflowContext);
    },
  });
}
